const CARD_ADD = 'CARD_ADD'
const CARD_ADD_SUCCESS = 'CARD_ADD_SUCCESS'
const CARD_ADD_ERROR = 'CARD_ADD_ERROR'

const CARD_PATCH = 'CARD_PATCH'
const CARD_PATCH_SUCCESS = 'CARD_PATCH_SUCCESS'
const CARD_PATCH_ERROR = 'CARD_PATCH_ERROR'

const CARD_MEDIA_ADD = 'CARD_MEDIA_ADD'
const CARD_MEDIA_ADD_SUCCESS = 'CARD_MEDIA_ADD_SUCCESS'
const CARD_MEDIA_ADD_ERROR = 'CARD_MEDIA_ADD_ERROR'

const CARD_MEDIA_DELETE = 'CARD_MEDIA_DELETE'
const CARD_MEDIA_DELETE_SUCCESS = 'CARD_MEDIA_DELETE_SUCCESS'
const CARD_MEDIA_DELETE_ERROR = 'CARD_MEDIA_DELETE_ERROR'

const CARD_LINK_ADD = 'CARD_LINK_ADD'
const CARD_LINK_ADD_SUCCESS = 'CARD_LINK_ADD_SUCCESS'
const CARD_LINK_ADD_ERROR = 'CARD_LINK_ADD_ERROR'

const CARD_LINK_DELETE = 'CARD_LINK_DELETE'
const CARD_LINK_DELETE_SUCCESS = 'CARD_LINK_DELETE_SUCCESS'
const CARD_LINK_DELETE_ERROR = 'CARD_LINK_DELETE_ERROR'

const CARD_SELECTION_PATCH = 'CARD_SELECTION_PATCH'
const CARD_SELECTION_PATCH_SUCCESS = 'CARD_SELECTION_PATCH_SUCCESS'
const CARD_SELECTION_PATCH_ERROR = 'CARD_SELECTION_PATCH_ERROR'

const CARD_SELECTION_ADD = 'CARD_SELECTION_ADD'
const CARD_SELECTION_ADD_SUCCESS = 'CARD_SELECTION_ADD_SUCCESS'
const CARD_SELECTION_ADD_ERROR = 'CARD_SELECTION_ADD_ERROR'

const CARD_SELECTION_DELETE = 'CARD_SELECTION_DELETE'
const CARD_SELECTION_DELETE_SUCCESS = 'CARD_SELECTION_DELETE_SUCCESS'
const CARD_SELECTION_DELETE_ERROR = 'CARD_SELECTION_DELETE_ERROR'

const GET_BADGES = 'GET_BADGES'
const GET_BADGES_SUCCESS = 'GET_BADGES_SUCCESS'
const GET_BADGES_ERROR = 'GET_BADGES_ERROR'

const COURSE_REMOVE_CARD = 'COURSE_REMOVE_CARD'
const COURSE_REMOVE_CARD_SUCCESS = 'COURSE_REMOVE_CARD_SUCCESS'
const COURSE_REMOVE_CARD_ERROR = 'COURSE_REMOVE_CARD_ERROR'

const CARD_SETTING_PATCH = 'CARD_SETTING_PATCH'
const CARD_SETTING_PATCH_SUCCESS = 'CARD_SETTING_PATCH_SUCCESS'
const CARD_SETTING_PATCH_ERROR = 'CARD_SETTING_PATCH_ERROR'

const CARD_SETTING_CREATE = 'CARD_SETTING_CREATE'
const CARD_SETTING_CREATE_SUCCESS = 'CARD_SETTING_CREATE_SUCCESS'
const CARD_SETTING_CREATE_ERROR = 'CARD_SETTING_CREATE_ERROR'

const CARD_SETTING_REMOVE = 'CARD_SETTING_REMOVE'

const COURSE_CARD_LINK_PATCH = 'COURSE_CARD_LINK_PATCH'
const COURSE_CARD_LINK_PATCH_SUCCESS = 'COURSE_CARD_LINK_PATCH_SUCCESS'
const COURSE_CARD_LINK_PATCH_ERROR = 'COURSE_CARD_LINK_PATCH_ERROR'

const CARD_CHANGE_IMAGE = 'CARD_CHANGE_IMAGE'

const ADD_CARD = 'ADD_CARD'
const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS'
const ADD_CARD_ERROR = 'ADD_CARD_ERROR'

const DELETE_SECTION = 'DELETE_SECTION'
const DELETE_SECTION_SUCCESS = 'DELETE_SECTION_SUCCESS'
const DELETE_SECTION_ERROR = 'DELETE_SECTION_ERROR'

const GET_CARD = 'GET_CARD'
const GET_CARD_SUCCESS = 'GET_CARD_SUCCESS'
const GET_CARD_ERROR = 'GET_CARD_ERROR'

const CLEAR_CARD_STATE = 'CLEAR_CARD_STATE'

const EDITOR_LOADING = 'EDITOR_LOADING'

const CARD_CLONE = 'CARD_CLONE'
const CARD_CLONE_SUCCESS = 'CARD_CLONE_SUCCESS'
const CARD_CLONE_ERROR = 'CARD_CLONE_ERROR'

const GET_CUSTOM_BADGES = 'GET_CUSTOM_BADGES'
const CREATE_CUSTOM_BADGE = 'CREATE_CUSTOM_BADGE'
const UPDATE_CUSTOM_BADGE = 'UPDATE_CUSTOM_BADGE'
const DELETE_CUSTOM_BADGE = 'DELETE_CUSTOM_BADGE'

export {
  CARD_ADD,
  CARD_ADD_SUCCESS,
  CARD_ADD_ERROR,
  CARD_PATCH,
  CARD_PATCH_SUCCESS,
  CARD_PATCH_ERROR,
  CARD_MEDIA_ADD,
  CARD_MEDIA_ADD_SUCCESS,
  CARD_MEDIA_ADD_ERROR,
  CARD_LINK_ADD,
  CARD_LINK_ADD_SUCCESS,
  CARD_LINK_ADD_ERROR,
  CARD_MEDIA_DELETE,
  CARD_MEDIA_DELETE_SUCCESS,
  CARD_MEDIA_DELETE_ERROR,
  CARD_SELECTION_PATCH,
  CARD_SELECTION_PATCH_SUCCESS,
  CARD_SELECTION_PATCH_ERROR,
  CARD_SELECTION_ADD,
  CARD_SELECTION_ADD_SUCCESS,
  CARD_SELECTION_ADD_ERROR,
  CARD_SELECTION_DELETE,
  CARD_SELECTION_DELETE_SUCCESS,
  CARD_SELECTION_DELETE_ERROR,
  CARD_LINK_DELETE,
  CARD_LINK_DELETE_SUCCESS,
  CARD_LINK_DELETE_ERROR,
  GET_BADGES,
  GET_BADGES_SUCCESS,
  GET_BADGES_ERROR,
  COURSE_REMOVE_CARD,
  COURSE_REMOVE_CARD_SUCCESS,
  COURSE_REMOVE_CARD_ERROR,
  CARD_SETTING_PATCH,
  CARD_SETTING_PATCH_SUCCESS,
  CARD_SETTING_PATCH_ERROR,
  CARD_SETTING_CREATE,
  CARD_SETTING_CREATE_SUCCESS,
  CARD_SETTING_CREATE_ERROR,
  CARD_SETTING_REMOVE,
  COURSE_CARD_LINK_PATCH,
  COURSE_CARD_LINK_PATCH_SUCCESS,
  COURSE_CARD_LINK_PATCH_ERROR,
  CARD_CHANGE_IMAGE,
  ADD_CARD,
  ADD_CARD_SUCCESS,
  ADD_CARD_ERROR,
  DELETE_SECTION,
  DELETE_SECTION_SUCCESS,
  DELETE_SECTION_ERROR,
  GET_CARD,
  GET_CARD_SUCCESS,
  GET_CARD_ERROR,
  CLEAR_CARD_STATE,
  EDITOR_LOADING,
  CARD_CLONE,
  CARD_CLONE_SUCCESS,
  CARD_CLONE_ERROR,
  GET_CUSTOM_BADGES,
  CREATE_CUSTOM_BADGE,
  UPDATE_CUSTOM_BADGE,
  DELETE_CUSTOM_BADGE,
}
